module.exports = __webpack_public_path__ + "img/load-grayscale.4b8512cd.gif";